import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {FormControl} from "@angular/forms";
import {IonInput} from "@ionic/angular";

@Component({
  selector: 'app-text-box',
  templateUrl: './text-box.component.html',
  styleUrls: ['./text-box.component.scss'],
})
export class TextBoxComponent implements OnInit {

  @ViewChild('input', { static: true }) inputElement!: IonInput;

  @Input() label: string;
  @Input() placeholder: string;
  @Input() iconName: string;
  @Input() iconCallback: Function;
  @Input() inputCallback: Function;
  @Input() control: FormControl;

  constructor() {
  }

  ngOnInit() {
  }

  focus() {
    this.inputElement.setFocus(); // ion-input usa il metodo `setFocus`
  }

  _iconCallback(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (this.iconCallback) {
      this.iconCallback()
    }
  }

  _inputCallback(event) {
    if (this.inputCallback && event.srcElement.nodeName == 'INPUT') {
      this.inputCallback()
    }
  }

}
